import { graphql } from "../generated";

export const SpecificationVersionsDocument = graphql(`
  query SpecificationVersions($key: ID!) {
    specification(key: $key) {
      key
      isSourceVariation
      deliverables {
        nodes {
          ...DeliverableDetails
        }
      }
      sourceDeliverable {
        ...DeliverableDetails
      }
      revisions {
        count
      }
    }
  }

  # The version list's per-version facts: the verdict and version
  # numbers, and the revision subgraph's contributions — the delivered-at
  # instants and the revision count (docs/revision-deliverable-graph-thinning
  # SCOPE.md, D3).
  fragment DeliverableDetails on Deliverable {
    key
    verdict
    versionInternal
    versionExternal
    hasReachedReviewStage
    internallyDeliveredAt
    externallyDeliveredAt
    revisions {
      count
    }
  }
`);
